<template>
  <qd-admin-auth pid="120">
    <div class="page-container">
      <v-page-header :title="$t('微信小程序账号')" />
      <template v-if="listTotal">
        <v-tip ref="bindTip" placement="right" :disabled="listTotal < maxCount">
          <span>{{ $t('最多绑定{n}个小程序', { n: maxCount }) }}</span>
        </v-tip>
        <div v-if="listTotal >= maxCount" v-tip:bindTip.hover :class="{ 'mini-auth-item--disabled': listTotal >= maxCount }"
          class="mini-auth-list_item"
        >
          <v-icon name="wx" />
          <h4>{{ $t('绑定微信小程序') }}</h4>
          <p>{{ $t('一键授权绑定小程序到企点') }}</p>
        </div>
        <div v-else class="mini-auth-list">
          <div class="mini-auth-list_item im" @click="onAuth">
            <div class="left">
              <v-icon name="wx" />
              <v-icon class="icon-info" name="wx-im" />
            </div>
            <div class="right">
              <h4>{{ $t('绑定小程序-在线客服') }}</h4>
              <p>{{ $t('一键授权绑定小程序到企点') }}</p>
            </div>
          </div>
          <div v-if="isCall" class="mini-auth-list_item call" @click="onAuthCall">
            <div class="left">
              <v-icon name="wxCall" />
              <v-icon class="icon-info" name="wx-call" />
            </div>
            <div class="right">
              <h4>{{ $t('绑定小程序-电话客服') }}</h4>
              <p>{{ $t('绑定小程序到企点用于电话客服') }}</p>
            </div>
          </div>
        </div>
        <div class="mini-auth-table">
          <grid ref="grid" :url="`/mp/miniprogram/getInfo`" :fetch="getList" data-path="/rows" total-path="/total">
            <v-table-column v-for="(column, index) in columns" :key="`grid-col-${index}`"
              :column-key="columnsOption[column].value" :label="$t(columnsOption[column].label)"
              :width="columnsOption[column].width" :align="columnsOption[column].align"
              :render="columnsOption[column].render"
            />
          </grid>
        </div>
        <div class="mini-auth-intro">
          <h3>{{ $t('说明') }}</h3>
          <p>{{ $t('1.绑定微信小程序后，配置接待后可以使用企点客户端接收客户从微信小程序发来的客服消息。') }}</p>
          <p>
            <i18n-t path="2.绑定微信小程序后，并部署监测SDK，可取用户基本信息，追踪用户在小程序的行为轨迹，下载安装SDK请查阅{config}。" tag="span">
              <a
                slot="config"
                href="https://admin.qidian.qq.com/hp/helpCenter/getArticle?id=12419" target="_blank"
              >{{ $t('小程序配置') }}</a>
            </i18n-t>
          </p>
        </div>
      </template>
      <template v-else>
        <div class="mini-auth-empty">
          <v-icon name="wx" />
          <h4>{{ $t('暂未绑定微信小程序账号') }}</h4>
          <p>{{ $t('绑定微信小程序账号到企点，开启微信客服接待新体验。') }}</p>
          <v-button status="primary" size="large" @click="onAuth">
            {{ $t('绑定在线小程序账号') }}
          </v-button>
          <v-button v-if="isCall" status="primary" size="large" @click="onAuthCall">
            {{ $t('绑定电话小程序账号') }}
          </v-button>
        </div>
      </template>
    </div>
  </qd-admin-auth>
</template>

<script>
import { Icon } from 'vhtml-ui';
import Grid from 'src/components/grid';
import conf from './conf';
import urlTool from '@/utils/urlTool';
const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
export default {
  components: {
    Grid,
  },

  data() {
    return {
      conf,

      columns: ['accountName', 'wxAppId', 'errorTips', 'config'],

      columnsOption: conf.miniGridConf.columnsOption,

      tableData: [],

      // 小程序最大值
      maxCount: 200,
      // 列表总值
      listTotal: 1,
    };
  },
  computed: {
    isCall() {
      const commonData  = window.QD_ADMIN_COMMON?.data || {};
      const ids = (commonData && commonData.set?.available.map(item => item.id)) || [];
      const isShow = window.pageData?.data.isShowMPBind;
      return (
        isShow
        && (ids.indexOf(10005) !== -1
          || ids.indexOf(10008) !== -1
          || ids.indexOf(10015) !== -1
          || ids.indexOf(10026) !== -1
          || ids.indexOf(10027) !== -1)
      );
    },
  },
  created() {
    const errMsg = urlTool.getUrlParameter('errMsg');
    if (errMsg) {
      this.$message.error(errMsg);
    }
  },
  methods: {
    //  请求列表数据
    async getList(url, params) {
      const data = await this.$ajax.gatewayGet(url, { params });
      this.maxCount = data && data.data && data.data.maxCount;
      this.listTotal = data && data.data && data.data.total;
      return data;
    },
    onAuth() {
      this.anAuthAjax(0);
    },

    onAuthCall() {
      this.anAuthAjax(1);
    },
    anAuthAjax(type) {
      /**
       * 要授权的帐号类型：1则商户点击链接后，手机端仅展示公众号、2表示仅展示小程序，3表示公众号和小程序都展示。如果为未指定，则默认小程序和公众号都展示。第三方平台开发者可以使用本字段来控制授权的帐号类型。
       * 参考: https://open.weixin.qq.com/cgi-bin/showdocument?action=dir_list&t=resource/res_list&verify=1&id=open1453779503&token=e55f9a39d3fe412711b24fd286009dfa81ca2232&lang=zh_CN
       */
      const params = {
        auth_type: 2,
        type: 1,
        miniProgramType: type,
      };

      this.$ajax
        .get(type === 0 ? conf.getAuthCgi : conf.getAuthCallCgi, {
          params,
        })
        .then((res) => {
          const url = type === 0
            ? `${conf.getAuthCgi
            }?jump=1&auth_type=2&stamp=${new Date().getTime()}&miniProgramType=${type}`
            : res.url;
            if (url) {
              window.location.href = url;
            } else {
              this.$message.error(res.msg || res.message || this.$t('访问出错，请重试'));
            }
        })
        .catch((err) => {
          this.$message.error(err.msg || this.$t('访问出错，请重试'));
        });
    },
    onUnbind(item) {
      const that = this;

      const dialog = this.$confirm({
        title: this.$t('解除绑定该小程序？'),
        status: 'warning',
        confirmText: this.$t('解绑'),
        confirm(e) {
          e.preventDefault();
          dialog.showButtonLoading();
          that.$ajax
            .delete(
              item.option.application === 1 ? conf.unbindCgi : conf.unbindCallCgi,
              {
                id: item.option.application === 1 ? item.option.row.id : item.option.row.wxAppId,
                application: item.option.application,
              },
              {
                transformRequest: data => JSON.stringify(data),
                headers: {
                  'Content-Type': 'application/json',
                },
              },
            )
            .then(() => {
              that.$message.success(that.$t('解绑成功'));
              dialog.$remove();
              window.location.reload();
            })
            .catch((err) => {
              that.$message.error(err.msg || that.$t('解绑失败'));
              dialog.$remove();
            });
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import './style.less';
</style>
